export default "__VITE_ASSET__UDrALy85__"